import _ from 'lodash';
import { tblShape } from './utils';

export default function table() {
  return {
    _id: false,
    type: 'droplet.table',
    header: _.times(2, tblShape()),
    body: [
      {
        cols: _.times(2, tblShape()),
      },
      {
        cols: _.times(2, tblShape()),
      },
    ],
    mediaQueries: [
      {
        selector: '.drzTable-head',
        properties: [
          {
            defaultColor: true,
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/table/droplet.schema.js